import libs from '@/libs';
import cf from '@/libs/common.function';

export function clearAll() {
  libs.locStorage.clear();
}

export function readCache(key) {
  const cache = libs.locStorage.get(key);

  if (!cache || !cache.expiredTime || cf.timeCompare(cache.expiredTime * 1000) === 'earlier') {
    return null;
  }

  return cache;
}

export function writeCache(key, value) {
  libs.locStorage.set(key, value);
}



// WEBPACK FOOTER //
// ./src/libs/cache.js